// extracted by mini-css-extract-plugin
module.exports = {"battle-chart-div":"ChartDiv_battle-chart-div__28F5o","arrow-img":"ChartDiv_arrow-img__azV9Q","battle-rating-control":"ChartDiv_battle-rating-control__1dVrk"};